/* istanbul ignore file */
import { TimerIcon } from 'assets';
import { FlexDiv } from 'components/Div/styles';
import styled from 'styled-components';
import { ParagraphXsmallRegular } from 'styles/elements/typography';

interface ChipContainerProps {
  backgroundColor?: string;
}

export const ChipContainer = styled(FlexDiv)<ChipContainerProps>`
  padding: 7px 8px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${({ backgroundColor }) => backgroundColor};
  border-radius: 6px;
  height: 32px;
`;

export const TimerText = styled(ParagraphXsmallRegular)`
  color: ${({ hasTimeLeft, theme }) => (hasTimeLeft ? theme.colorActionPrimaryHover : theme.colorPrimaryPrimary10)};
`;

interface StyledTimerIconProps {
  hasTimeLeft: boolean;
}

export const StyledTimerIcon = styled(TimerIcon)<StyledTimerIconProps>`
  color: ${({ hasTimeLeft, theme }) => (hasTimeLeft ? theme.colorActionPrimaryHover : theme.colorPrimaryPrimary10)};
`;
